/**
 * Clinic interface for utility functions
 */
export interface Clinic {
  id: number;
  name: string;
}

/**
 * Gets display name for clinic by ID
 * @param clinicId - Clinic ID number or null
 * @param clinics - Array of available clinics
 * @returns Clinic name or fallback display string
 */
export const getClinicDisplayName = (clinicId: number | null, clinics: Clinic[]): string => {
  if (!clinicId) {
    return 'Not assigned';
  }
  const clinic = clinics.find((c) => c.id === clinicId);
  return clinic?.name || `Clinic ${clinicId}`;
};
